import type {ProDateRange} from '../../types';
import type {DateRangeValue} from '@date-picker';

import {dateToReadableDate, RangeCalendar} from '@date-picker';

type ProRangePickerProps = {
  date: ProDateRange;
  onChangeDate: (date: ProDateRange) => void;
};

const ProRangePicker: React.FC<ProRangePickerProps> = ({date, onChangeDate}) => {
  const handleChange = (value: DateRangeValue) => {
    onChangeDate({
      start: value.start ?? null,
      end: value.end ?? null
    });
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col justify-between overflow-hidden">
      <RangeCalendar
        onChange={handleChange}
        value={{start: date.start ?? undefined, end: date.end ?? undefined}}
        numberOfMonths={6}
        allowRange={false}
      />
      <div className="flex border-t border-gray-22 px-4 py-3">
        <div className="flex-1">
          <span className="text-body-xs text-gray-34">تاریخ شروع</span>
          <p className="mt-2 text-subtitle-md text-neutral-fg">
            {date.start
              ? dateToReadableDate({date: date.start, day: true, month: true, year: true})
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProRangePicker;
